const defaultPortSearchResults = [
  {
    'portId': 2537,
    'portName': 'Richards Bay',
    'unlocode': 'ZARCB',
    'countryCode': 'ZA',
    'entityType': 'PORT',
    'geomPoint': '{"type":"Point","coordinates":[32.0259853867974,-28.8043198119649]}',
    'mbcRadius': 0.116189927180328,
    'id': 'port-2537',
    'value': 'port-2537',
    'text': 'Richards Bay'
  },
  {
    'portId': 1358,
    'portName': 'Gangavaram',
    'unlocode': 'INGGV',
    'countryCode': 'IN',
    'entityType': 'PORT',
    'geomPoint': '{"type":"Point","coordinates":[83.2125602342484,17.6185585590098]}',
    'mbcRadius': 0.0851989107170949,
    'id': 'port-1358',
    'value': 'port-1358',
    'text': 'Gangavaram'
  },
];

export {
  defaultPortSearchResults,
}